import React from 'react'

import styles from './workflow-sidebar.module.scss'
import { ReactComponent as CloseIcon } from 'assets/img/close.svg'
import { WorkflowCreationContext } from '../WorkflowCreation2/WorkflowCreation2'

const WorkflowEditSideBar = (
    {
        editElement,
        actionType,
        isAction = false
    }:
        {
            editElement: any,
            actionType: any
            isAction?: boolean
        }
) => {

    const { closeSideBarOnMobile, setCloseSideBarOnMobile } = React.useContext(WorkflowCreationContext);


    React.useEffect(() => {
        if (window.innerWidth <= 767) {
            setCloseSideBarOnMobile(false)
        } else {
            setCloseSideBarOnMobile(true)
        }
    }, [window.innerWidth])

    return (
        <div
            // className={styles.WorkflowSidebar}
            className={`${styles.WorkflowSidebar} ${actionType === 'filter' ? styles.WorkflowSidebar__Filter : ''}`}

            style={{ display: closeSideBarOnMobile ? 'block' : 'none' }}
        >
            <div className={`${styles.WorkflowSidebar__header} ${actionType === 'filter' ? styles.WorkflowSidebar__header__filter : ''}`}>
                <span className={styles.closeMobile}>
                    <CloseIcon onClick={() => {
                        setCloseSideBarOnMobile(false)
                    }} />
                </span>
                <>
                    {
                        actionType === 'filter'
                            ?
                            <div className={`${styles.WorkflowSidebar__Filter__header}`}>
                                <h1>Filter conditions</h1>
                                <span className={styles.WorkflowSidebar__header__actionLabel}>
                                    Add filter condtions to your workflow.
                                </span>
                            </div>
                            :
                            <>
                                {
                                    isAction ?
                                        <>
                                            <h1>Choose an event</h1>
                                            <span className={styles.WorkflowSidebar__header__actionLabel}>
                                                Select which actions will start your workflow.
                                            </span>
                                        </>
                                        :
                                        <>
                                            {
                                                actionType && actionType.type && actionType.type.includes('delay')
                                                    ?
                                                    <>
                                                        <h1>Add time delay</h1>
                                                        <span className={styles.WorkflowSidebar__header__actionLabel}>
                                                            Add a time delay to workflow step.
                                                        </span>
                                                    </>
                                                    :
                                                    <>
                                                        <h1>Choose an action</h1>
                                                        <span className={styles.WorkflowSidebar__header__actionLabel}>
                                                            Select which action to apply when a user reaches the next action step.
                                                        </span>
                                                    </>
                                            }
                                        </>
                                }
                            </>
                    }
                </>
            </div>

            <div className={styles.WorkflowSidebar__body}>
                <div className={styles.WorkflowSidebar__body__content}>
                    {
                        editElement
                    }
                </div>
            </div>

        </div>
    )
}

export default WorkflowEditSideBar